import * as S from './PreferencesSaved.styles'
import TopBar from '../../elements/TopBar/TopBar'
import { photosTheme as theme } from 'mixtiles-web-common'
import { translateManager as t } from '../../services/TranslateManager'
import Button from 'mixtiles-web-common/ui/Button/Button'
import useOnMount from '../../hooks/useOnMount'
import { analytics, SCREENS } from '../../services/Analytics/Analytics'
import { RouteLink } from 'components/RouteLink/RouteLink'

export default function PreferencesSaved() {
  useOnMount(() => {
    analytics.trackScreenView(SCREENS.PREFERENCES_SAVED)
  })

  return (
    <>
      <TopBar
        backgroundColor={theme.colors.grayAccent}
        rightButton={null}
        leftButton={null}
        noBorder
      />
      <S.Background>
        <S.Container>
          <S.Thumbnail src="https://res.cloudinary.com/mixtiles/image/upload/v1719831838/assets/illustrations/Moments/hand_with_moments_blank.svg" />
          <S.TextContainer>
            <S.Title>{t.get('preferences_saved.title')}</S.Title>
            <S.Subtitle>{t.get('preferences_saved.subtitle')}</S.Subtitle>
          </S.TextContainer>
          <RouteLink to="/">
            <Button minWidth={246}>{t.get('preferences_saved.cta')}</Button>
          </RouteLink>
        </S.Container>
      </S.Background>
    </>
  )
}
